import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import React from "react";
import { useQuery } from "react-query";
import { LanguageDto, ReferentialItemDto } from "../../api";
import { useCommonHooks, useLanguages } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface ILanguageSelectProps
  extends Pick<IFGSelectInputProps<any>, "requiredMark"> {
  name: string;
  label?: string;
}

export const LanguageSelect: React.FunctionComponent<ILanguageSelectProps> = ({
  name,
  label,
  ...fgSelectInputProps
}) => {
  const { t, apis } = useCommonHooks();
  const { languages, loadingLanguages } = useLanguages();
  React.useEffect(() => {
    console.log("languages", languages);
  }, [languages]);
  return (
    <FGSelectInput
      label={label || t(ETLCodes.Language)}
      name={name}
      items={languages}
      loading={loadingLanguages}
      displayField={nameof<LanguageDto>("label")}
      valueField={nameof<LanguageDto>("id")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
